import { MenuIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import JournalExplorer, { JournalExplorerContext, JournalExplorerFeatures } from "./JournalExplorer";

interface Props {
  context?: JournalExplorerContext;
  features?: JournalExplorerFeatures;
  tagCount: Record<string, number>;
  tickerCount: Record<string, number>;
}

const JournalExplorerDrawer = (props: Props) => {
  const { context, features, tagCount, tickerCount } = props;
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost">
          <MenuIcon className="size-5 text-foreground" />
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-80 max-w-full bg-background">
        <SheetHeader>
          <SheetTitle />
        </SheetHeader>
        <JournalExplorer className="px-4" context={context} features={features} tagCount={tagCount} tickerCount={tickerCount} />
      </SheetContent>
    </Sheet>
  );
};

export default JournalExplorerDrawer;
